import { HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../app.service';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class KlenicoMeService {

    CORE = 'stories/core';
    COMPONENT = '';
    isLandingPage = false;
    isProfilePage = false;
    SRSTEPS = {
        FEELING_SMOKE_DETECTOR: 1,
        FEELING_SELECTION: 2,
        FEELING_RATING: 3,
        ANAMESTIC_SELECTION: 4,
        FINAL: 5
    };
    PATIENTSTEPS = {
        NOTSTART: 0,
        SR: 1,
        EVALUATION_INTERVIEW: 2,
        EXPORT_RECOMMENTDATION: 3
    };
    TRIGGERS = {
        Login : 0,
        DocumentNotification: 0, // To show total document
        Document: 0, // To show document card
        NoShow: 0,
        Show: 0,
        Register: 0,
        DynamicReportCreated: 0,
        EvaluationDone: 0,
    };

    TRIGGER_NOTIFICATIONS = {
        Login : "Login",
        DocumentNotification: "DocumentNotification",
        Document: "Document",
        NoShow: "NoShow",
        Show: 0,
        Register: "Register",
        DynamicReportCreated: "DynamicReportCreated",
        EvaluationDone: "EvaluationDone",
    };

    packagesList : any;
    patientStep : number;
    srStep: number;
    isNonMedicalFooter = false;
    nextCreateSr;
    notifications = [];

    constructor(
        public secureApi: SecureApi,
        public appService: AppService,
        public translateService: TranslateService,
        public http : HttpClient,
        @Inject('storyBlokToken') public storyBlokToken: string,
        @Inject('storyBlokAPI') public storyBlokAPI: string,
    ) {
    }

    setKlenicoMeData(data){
        let service = this;
        for(let attr in data){
            service[attr] = data[attr];
        }
    }

    getStoryBlokAPI(){
        return this.storyBlokAPI + '/' +this.CORE + '/' + this.COMPONENT + '/';
    }

    checkVoucher(voucher) {
        return this.secureApi.get('patients/get-clinic-voucher/' + voucher);
    }

    /**
     * Submit reactive form
     *
     * @param {string} url
     * @param {number} id
     * @param model
     * @param {number} currentPage
     * @param {number} itemsPerPage
     * @param {string} sortedColumn
     * @param {string} order
     * @param searchInfo
     * @returns {Observable<Response>}
     */
    submit(url: string, id: number, model: any) {
        // add url query parameters
        let body = '';

        let firstParam = true;
        if (id != null) {
            body = 'id=' + id;
            firstParam = false;
        }

        let paramBuilder = new URLSearchParams();

        for (let column in model) {
            if (model.hasOwnProperty(column) && model[column] !== null) {
                paramBuilder.append(column, Array.isArray(model[column]) ? JSON.stringify(model[column]) : model[column]);
            }
        }

        let modelProperties = paramBuilder.toString();
        if (firstParam) {
            body += modelProperties;
        } else {
            body += '&' + modelProperties;
        }

        body += '&';

        if (id != null) {
            return this.secureApi.put(url + '/update/' + id, body, true);
        }

        return this.secureApi.post(url + '/create', body, true);
    }

    getDashboard() {
        return this.secureApi.get('b2c-patients/dashboard');
    }

    docToText(doc) {
        const { type, content } = doc;
        return this.docNodesToText(content);
    }

    docNodeToText(node) {
        const { type } = node;
      
        if (type === "text") {
          return node.text;
        }
      
        if (type === "hard_break") {
          return "";
        }
      
        if (type === "image") {
          return "";
        }
      
        if (type === "horizontal_rule") {
          return "";
        }
      
        return this.docNodesToText(node.content);
    }
      
    docNodesToText(nodes = []) {
        return nodes.map(node => this.docNodeToText(node)).join("\n");
    }
}
